import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
interface CountdownPanelProps {
  headline: string;
  subtext: string;
}
export function CountdownPanel({
  headline,
  subtext
}: CountdownPanelProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: 'ore'
  }, {
    value: minutes,
    label: 'minuti'
  }, {
    value: seconds,
    label: 'secondi'
  }];
  return <div className="mx-auto w-full max-w-3xl rounded-2xl bg-pink-900 px-6 py-8 text-center ring-1 ring-pink-800 md:px-10" data-id="element-34" data-mp="l8rwb8tj45rd">
      <p className="inline-flex items-center gap-2 text-sm font-extrabold uppercase tracking-widest text-white md:text-base" data-id="element-35" data-mp="c68zb5cfcnd1">
        <AlertTriangleIcon className="h-5 w-5 shrink-0 text-amber-300" aria-hidden="true" data-id="element-36" data-mp="h63pf6odl8x1" />
        {headline}
      </p>

      <div className="mt-6 flex items-start justify-center gap-5 md:gap-9" role="timer" data-id="element-37" data-mp="26kjlf61mx3f4">
        {units.map(unit => <div key={unit.label} className="flex flex-col items-center" data-id="element-38" data-mp="2bh0jot2jsy5x">
            <span className="text-5xl font-extrabold tabular-nums leading-none tracking-tight text-white md:text-6xl" data-id="element-39" data-mp="1lfnge84bc6qj">
              {unit.value}
            </span>
            <span className="mt-2 text-xs font-bold uppercase tracking-widest text-pink-200" data-id="element-40" data-mp="1v7jj5whcgl13">
              {unit.label}
            </span>
          </div>)}
      </div>

      <p className="mt-6 font-semibold text-pink-100" data-id="element-41" data-mp="12icl0ylsxxgd">{subtext}</p>
    </div>;
}